const removeCommasAndDotsFromString = (value) => {
  const val = `${value}`;
  return val.split('.').join('').split(',').join('');
};

const isNumberPositiveAndLessThan = (value, max) => {
  const val = removeCommasAndDotsFromString(value);
  const valAsInteger = parseInt(val, 10);
  return (
    Number.isInteger(valAsInteger) &&
    valAsInteger > 0 &&
    (!max || valAsInteger <= max)
  );
};
const isNumberPositiveAndMoreThan = (value, min) => {
  const val = removeCommasAndDotsFromString(value);
  const valAsInteger = parseInt(val, 10);
  return (
    Number.isInteger(valAsInteger) &&
    valAsInteger > 0 &&
    (!min || valAsInteger >= min)
  );
};
const isNumberPositive = (value) => isNumberPositiveAndLessThan(value, false);

const stringMaskedToNumber = (str) =>
  str === '' ? '' : Number(removeCommasAndDotsFromString(str));

export {
  removeCommasAndDotsFromString,
  isNumberPositiveAndLessThan,
  isNumberPositive,
  isNumberPositiveAndMoreThan,
  stringMaskedToNumber,
};

export default undefined;
